import * as ResourceReducer from './resource.reducer';
import * as ResourceSelectors from './resource.selectors';
import * as ResourceActions from './resource.actions';

export { ResourceReducer, ResourceSelectors, ResourceActions };
